<app-card
	cardTitle
	cardClass="card-datatable"
	[options]="false">
	<form
		(ngSubmit)="search()"
		class="filterform">
		<div class="row">
			<div class="col-md-6">
				<div class="form-group d-flex flex-row">
					<input
						type="text"
						class="form-control d-inline"
						name="keyword"
						placeholder="Cerca..."
						[(ngModel)]="searchparams.genericSearchTerm">
					<button
						type="button"
						class="btn btn-link ml-2"
						(click)="toggleAdvanced()">
						<i class="feather icon-filter"></i>

					</button>
				</div>
			</div>
			<div class="col-md-4 mt-1">
				<div class="form-group">
					<div class="form-check form-check-inline">
						<input
							type="checkbox"
							class="form-check-input"
							name="active"
							[(ngModel)]="active">
						<label class="form-check-label">
							{{'labels.show-only-active' | translate}}
						</label>
					</div>
				</div>
			</div>

		</div>
		<div [ngbCollapse]="!showAdvancedSearch">
			<div class="row">
				<div class="col-md-4">
					<div class="form-group">
						<label>{{'labels.name' | translate}}</label>
						<input
							type="text"
							class="form-control"
							name="fname"
							[(ngModel)]="searchparams.likeTmp['fname']">
					</div>
				</div>
				<div class="col-md-4">
					<div class="form-group">
						<label>{{'labels.lname' | translate}}</label>
						<input
							type="text"
							class="form-control"
							name="lname"
							[(ngModel)]="searchparams.likeTmp['lname']">
					</div>
				</div>
				<div class="col-md-4">
					<div class="form-group">
						<label>{{'labels.email' | translate}}</label>
						<input
							type="text"
							class="form-control"
							name="email"
							[(ngModel)]="searchparams.likeTmp['email']">
					</div>
				</div>
				<div class="col-md-4">
					<div class="form-group">
						<label>{{'labels.cf' | translate}}</label>
						<input
							type="text"
							class="form-control"
							name="cf"
							[(ngModel)]="searchparams.likeTmp['cf']">
					</div>
				</div>
				<div class="col-md-4">
					<div class="form-group">
						<label>{{'labels.mobileno' | translate}}</label>
						<input
							type="text"
							class="form-control"
							name="mobileno"
							[(ngModel)]="searchparams.likeTmp['mobileno']">
					</div>
				</div>
				<div class="col-md-4">
					<div class="form-group">
						<label>{{'labels.province' | translate}}</label>
						<app-entity-autocomplete
							entityName="province"
							entityField="descrizione"
							entityFilterType="like"
							[entitySearch]="provinciaSearch"
							name="provincia"
							[(ngModel)]="provincia"
							placeholder>
						</app-entity-autocomplete>
					</div>
				</div>
				<div class="col-md-4 mb-1">
					<label>{{'labels.daylyhrs' | translate}}</label>
					<div class="row">
						<div class="col-md-3">{{'labels.from' | translate}}:</div>
						<div class="col-md-3">
							<input
								type="number"
								class="form-control"
								name="from"
								[(ngModel)]="daylyhrs.from">
						</div>
						<div class="col-md-3">{{'labels.to' | translate}}:</div>
						<div class="col-md-3">
							<input
								type="number"
								class="form-control"
								name="to"
								[(ngModel)]="daylyhrs.to">
						</div>
					</div>

				</div>
				<div class="col-md-4 mb-1">
					<label>
						{{'labels.basehourlysalary' | translate}}
					</label>
					<div class="row">
						<div class="col-md-3">{{'labels.from' | translate}}:</div>
						<div class="col-md-3">
							<input
								type="number"
								class="form-control"
								name="from2"
								[(ngModel)]="basehourlysalary.from">
						</div>

						<div class="col-md-3">{{'labels.to' | translate}}:</div>
						<div class="col-md-3">
							<input
								type="number"
								class="form-control"
								name="to2"
								[(ngModel)]="basehourlysalary.to">
						</div>
					</div>

				</div>
				<div class="col-md-4"></div>
				<div
					class="col-md-4"
					*ngIf="!companyid">
					<label>{{'labels.company' | translate}}</label>
					<app-entity-autocomplete
						entityName="company"
						entityField="name"
						entityFilterType="like"
						[entitySearch]="company.search"
						name="company"
						[(ngModel)]="company.selected"
						placeholder>
					</app-entity-autocomplete>

				</div>
				<div class="col-md-4">
					<div class="form-group">
						<label>{{'labels.contracttype' | translate}}</label>
						<select
							class="form-control custom-select"
							[(ngModel)]="searchparams.simpleTmp['contract']"
							name="contract">
							<option
								*ngFor="let contract of contracttypes"
								[value]="contract.itemvalue">
								{{contract.itemlabel}}
							</option>
						</select>
					</div>
				</div>
				<div class="col-md-4">
					<div class="form-group">
						<label>{{'labels.contractlevel' | translate}}</label>
						<select
							class="form-control custom-select"
							[(ngModel)]="searchparams.simpleTmp['contractlevel']"
							name="contract">
							<option
								*ngFor="let contract of contractlevels"
								[value]="contract.itemvalue">
								{{contract.itemlabel}}
							</option>
						</select>
					</div>
				</div>

			</div>

		</div>
		<div class="row mt-1">
			<div class="col">
				<button
					type="submit"
					class="btn btn-primary">
					{{'labels.search' | translate}}
				</button>
				<a
					(click)="resetSearch()"
					class="btn btn-default">
					{{'labels.reset' | translate}}
				</a>
			</div>

		</div>
	</form>
</app-card>
